import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { ErrorType } from 'src/app/enums/error-type.enum';
import endpoints from 'src/app/helpers/endpoints';
import { ApiService } from 'src/app/services/api.service';
import { ClaimActionModalComponent } from '../components/modals/claim-action-modal/claim-action-modal.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { StorageService } from 'src/app/services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class ClaimActionsService {

  constructor(private apiService : ApiService,  public dialog: MatDialog, private storageService : StorageService) { }

  private fetchViewClaimData$ = new BehaviorSubject(false);

  public shouldViewFetchClaims$ = this.fetchViewClaimData$.asObservable();

  private fetchCancelClaimData$ = new BehaviorSubject(false);

  public shouldCancelFetchClaims$ = this.fetchCancelClaimData$.asObservable();

  //For All File Claims Listing
  private fetchFileClaimList$ = new BehaviorSubject(false);
  public shouldFetchFileClaimList$ = this.fetchFileClaimList$.asObservable();
  

  claimsConciergeFrom = new FormGroup({
    userId: new FormControl("", [Validators.required]),
  });
  dispatcherForm = new FormGroup({
    userId: new FormControl("", [Validators.required]),
  });
  supervisorForm = new FormGroup({
    userId: new FormControl("", [Validators.required]),
  });
  authorizerForm = new FormGroup({
    userId: new FormControl("", [Validators.required]),
  });
  technicianForm = new FormGroup({
    userId: new FormControl("", [Validators.required]),
    technicianId: new FormControl(null),
  });
  addOutcomeForm = new FormGroup({
    value: new FormControl("", [Validators.required]),
    note: new FormControl("", [Validators.required]),
  });
  addPayoutForm = new FormGroup({
    value: new FormControl("", [Validators.required]),
    note: new FormControl("", [Validators.required]),
  });
  recallForm = new FormGroup({
    value: new FormControl("", [Validators.required]),
    note: new FormControl("", [Validators.required]),
  });
  chargeCopayForm = new FormGroup({
    value: new FormControl("", [Validators.required]),
  });
  payCustomerForm = new FormGroup({
    value: new FormControl("", [Validators.required]),
    note: new FormControl("", [Validators.required]),
  });
  payTechnicianForm = new FormGroup({
    value: new FormControl("", [Validators.required]),
    note: new FormControl("", [Validators.required]),
  });
  orderPartsForm = new FormGroup({
    name: new FormControl("", [Validators.required]),
    make: new FormControl("", [Validators.required]),
    model: new FormControl("", [Validators.required]),
    serial: new FormControl("", [Validators.required]),
    cost: new FormControl("", [Validators.required]),
  });
  technicianScheduleForm = new FormGroup({
    value: new FormControl("", [Validators.required]),
    technicianName: new FormControl(""),
    arrivalWindow: new FormControl("", [Validators.required]),
    appliedToRepair: new FormControl(false, [Validators.required]),
    scheduledAppointmentNote: new FormControl("", [Validators.required]),
    technicianRatings: new FormControl("", [Validators.required, Validators.min(1), Validators.max(10)]),
    technicianId: new FormControl("", [Validators.required]),
  });
  diagnosisForm = new FormGroup({
    value: new FormControl("", [Validators.required]),
    note: new FormControl("", [Validators.required]),
  });
  escalateClaimForm = new FormGroup({
    value: new FormControl("", [Validators.required]),
    note: new FormControl("", [Validators.required]),
  });
  claimInfoForm = new FormGroup({
    phoneNumber: new FormControl("", [
      Validators.required,
      Validators.pattern(/^[2-9][0-8]\d{1}[2-9]\d{2}\d{4}$/),
    ]),
    emailAddress: new FormControl("", [
      Validators.required,
      Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/),
    ]),
    contactPerson: new FormControl("", [Validators.required]),
    contactPhoneNumber: new FormControl("", [
      Validators.required,
      Validators.pattern(/^[2-9][0-8]\d{1}[2-9]\d{2}\d{4}$/),
    ]),
    contactEmailAddress: new FormControl("", [
      Validators.required,
      Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/),
    ]),
    updateClaimInfoNote: new FormControl("", [Validators.required]),
  });
  cancelClaimForm = new FormGroup({
    note: new FormControl("", [Validators.required]),
  });

  assignCurrentUserForm = new FormGroup({
    value: new FormControl([], [Validators.required]),
  });
  purchaserForm = new FormGroup({
    userId: new FormControl("", [Validators.required]),
  });
  orderReplacementForm = new FormGroup({
    orderedFrom: new FormControl("", [Validators.required]),
    orderedDate: new FormControl(null, [Validators.required]),
    tracking: new FormControl("", [Validators.required]),
    deliveryDate: new FormControl(null, [Validators.required]),
    ageOfItem: new FormControl("", [Validators.required]),
    itemType: new FormControl("", [Validators.required]),
    brand: new FormControl("", [Validators.required]),
    model: new FormControl("", [Validators.required]),
    serial: new FormControl("", [Validators.required]),
    color: new FormControl("", [Validators.required]),
    size: new FormControl("", [Validators.required]),
    notes: new FormControl("", [Validators.required]),
    hallaway: new FormControl(false, [Validators.required]),
    itemCost: new FormControl("", [Validators.required]),
    installationCost: new FormControl("", [Validators.required]),
    hallawayCost: new FormControl("", [Validators.required]),
    outcome: new FormControl("", [Validators.required]),
    completedNote: new FormControl("", [Validators.required]),
  });

  formList = {
    assignClaimsConcierge: this.claimsConciergeFrom,
    assignCoordinator: this.dispatcherForm,
    assignSupervisor: this.supervisorForm,
    assignOrEditTechnician: this.technicianForm,
    addOutcome: this.addOutcomeForm,
    addPayout: this.addPayoutForm,
    recall: this.recallForm,
    chargeCopay: this.chargeCopayForm,
    payCustomer: this.payCustomerForm,
    payTechnician: this.payTechnicianForm,
    addTechnicianSchedule: this.technicianScheduleForm,
    orderParts: this.orderPartsForm,
    uploadDiagnosis: this.diagnosisForm,
    escalateClaim: this.escalateClaimForm,
    updateClaimInfo: this.claimInfoForm,
    cancelClaim: this.cancelClaimForm,
    assignCurrentUser: this.assignCurrentUserForm,
    assignPurchaser: this.purchaserForm,
    orderReplacement: this.orderReplacementForm
  };

  
updateFileClaimInfo(
  fileClaimId: string,
  actionValue: any,
  modalName: string,
  isOpenScheduleTechnicianModal = false
) {
  const agentId = this.storageService.getUser()?.userId;
  const payload = this.createPayload(modalName, actionValue, agentId);
  this.fetchViewClaimData$.next(false);
  this.fetchFileClaimList$.next(false);
  const apiMethod =
    modalName === "uploadDiagnosis"
      ? this.apiService.postMultiData(
          endpoints.customerDashboard.updateFileClaimInfo(
            fileClaimId,
            modalName
          ),
          payload
        )
      : this.apiService.post(
          endpoints.customerDashboard.updateFileClaimInfo(
            fileClaimId,
            modalName
          ),
          payload
        );

  apiMethod.pipe(take(1)).subscribe(
    (res: any) => {
      this.apiService.alert(res.body.message, ErrorType.Success);
      this.fetchViewClaimData$.next(true);
      this.fetchCancelClaimData$.next(false);
      this.fetchFileClaimList$.next(true);
      if (modalName === "cancelClaim" || modalName === "assignOrEditTechnician") {
        this.fetchCancelClaimData$.next(true);
      }
      if(modalName === "assignOrEditTechnician" && isOpenScheduleTechnicianModal){
        this.openActionModal(fileClaimId, 'addTechnicianSchedule')

      }
    },
    (err: HttpErrorResponse) => {
      this.apiService.alert(err.message, ErrorType.Error);
    }
  );
}

createPayload(modalName: string, actionValue: any, agentId) {
  let payload: any = {};

  switch (modalName) {
    case "sendAnEmail":
      payload = {};
      break;

    case "cancelClaim":
      payload = {
        note: actionValue?.note,
        agentId: agentId,
        assignedBy: agentId
      };
      break;

      case "assignOrEditTechnician":
        payload = {
          actionValue: actionValue,
          assignedBy: agentId
        };
        break;

    case "payCustomer":
      payload = {
        actionValue: actionValue?.value,
        customerPaymentNote: actionValue?.note,
        assignedBy: agentId
      };
      break;

    case "uploadDiagnosis":
      const data: FormData = new FormData();
      data.append("actionValue", actionValue?.value);
      data.append("note", actionValue?.note);
      data.append("assignedBy", agentId)
      data.append("category", 'diagnosis')
      payload = data;
      break;

    case "updateClaimInfo":
      payload = {
        actionValue: actionValue,
        assignedBy: agentId
      };
      break;

    case "cancelClaim":
      payload = {
        note: actionValue?.note,
        agentId: agentId,
        assignedBy: agentId
      };
      break;

    case "addTechnicianSchedule":
      payload = {
           "agentId": agentId,
           "assignedBy": agentId,
          "actionValue": {
              "timeOfAppointment": moment(actionValue?.value).format("YYYY-MM-DD HH:mm:ss"),
              "arrivalWindow": this.technicianScheduleForm.get('arrivalWindow').value,
              "appliedToRepair": this.technicianScheduleForm.get('appliedToRepair').value,
              "scheduledAppointmentNote": this.technicianScheduleForm.get('scheduledAppointmentNote').value,
              "technicianRatings":  this.technicianScheduleForm.get('technicianRatings').value,
              "technicianId": this.technicianScheduleForm.get('technicianId').value,
          }
      } ;
   
      break;
      case "orderReplacement":
      payload = actionValue;
      payload.orderedDate = moment(actionValue?.orderedDate).format("YYYY-MM-DD HH:mm:ss");
      payload.deliveryDate = moment(actionValue?.deliveryDate).format("YYYY-MM-DD HH:mm:ss");
      payload.assignedBy = agentId
      break;

    default:
      if (
        [
          "addOutcome",
          "recall",
          "escalateClaim",
          "addPayout",
          "payTechnician",
        ].includes(modalName)
      ) {
        payload = {
          actionValue: actionValue?.value,
          note: actionValue?.note,
          agentId: agentId,
          assignedBy: agentId
        };
      } else {
        payload = {
          actionValue,
          assignedBy: agentId
        };
      }
      break;
  }
  return payload;
}


openActionModal(fileClaimId: any, modalName: string , services = null, zipCode = null, coverItemId = null) {

  const data = {
    fileClaimId,
    formGroup: this.formList[modalName],
    actionModal: modalName,
    services : services,
    zipCode,
    coverItemId
  };
  this.dialog
    .open(ClaimActionModalComponent, {
      data: data,
      width: modalName === 'orderReplacement' ? "900px" : modalName === 'assignOrEditTechnician' ? "1200px" : "600px",
      panelClass: "payment-info",
    })
    .afterClosed()
    .subscribe((res: any) => {
      if (!res?.actionValue) return;

      switch (modalName) {
        case "assignClaimsConcierge": {
          this.updateFileClaimInfo(
            fileClaimId,
            res?.actionValue?.userId,
            modalName
          );
          break;
        }
        case "assignCoordinator": {
          this.updateFileClaimInfo(
            fileClaimId,
            res?.actionValue?.userId,
            modalName
          );
          break;
        }
        case "assignSupervisor": {
          this.updateFileClaimInfo(
            fileClaimId,
            res?.actionValue?.userId,
            modalName
          );
          break;
        }
        case "assignOrEditTechnician": {
          this.updateFileClaimInfo(
            fileClaimId,
            {
              "technicianId": res?.actionValue?.technicianId || null,
              "companyId":res?.actionValue?.userId
          },
            modalName,
            res?.actionValue?.isOpenScheduleTechnicianModal
          );
          break;
        }
        case "addOutcome": {
          this.updateFileClaimInfo(
            fileClaimId,
            res?.actionValue,
            modalName
          );
          break;
        }
        case "addPayout": {
          this.updateFileClaimInfo(
            fileClaimId,
            res?.actionValue,
            modalName
          );
          break;
        }
        case "recall": {
          this.updateFileClaimInfo(
            fileClaimId,
            res?.actionValue,
            modalName
          );
          break;
        }
        case "chargeCopay": {
          this.updateFileClaimInfo(
            fileClaimId,
            res?.actionValue?.value,
            modalName
          );
          break;
        }
        case "payCustomer": {
          this.updateFileClaimInfo(
            fileClaimId,
            res?.actionValue,
            modalName
          );
          break;
        }
        case "payTechnician": {
          this.updateFileClaimInfo(
            fileClaimId,
            res?.actionValue,
            modalName
          );
          break;
        }
        case "orderReplacement": {
          this.updateFileClaimInfo(
            fileClaimId,
            res?.actionValue,
            modalName
          );
          break;
        }
        case "orderParts": {
          this.updateFileClaimInfo(
            fileClaimId,
            res?.actionValue,
            modalName
          );
          break;
        }
        case "addTechnicianSchedule": {
          this.updateFileClaimInfo(
            fileClaimId,
            res?.actionValue,
            modalName
          );
          break;
        }
        case "uploadDiagnosis": {
          this.updateFileClaimInfo(
            fileClaimId,
            res?.actionValue,
            modalName
          );
          break;
        }
        case "escalateClaim": {
          this.updateFileClaimInfo(
            fileClaimId,
            res?.actionValue,
            modalName
          );
          break;
        }
        case "updateClaimInfo": {
          this.updateFileClaimInfo(
            fileClaimId,
            res?.actionValue,
            modalName
          );
          break;
        }
        case "cancelClaim": {
          this.updateFileClaimInfo(
            fileClaimId,
            res?.actionValue,
            modalName
          );
          break;
        }
        case "assignCurrentUser": {
          this.updateFileClaimInfo(
            fileClaimId,
            res?.actionValue?.value,
            modalName
          );
          break;
        }
        case "assignPurchaser": {
          this.updateFileClaimInfo(
            fileClaimId,
            res?.actionValue?.userId,
            modalName
          );
          break;
        }
        default: {
          break;
        }
      }
    });
}

setFetchCancelClaimData(isFetch: boolean){
  this.fetchCancelClaimData$.next(isFetch);
}

}
